/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react'
import { FilterWithSelectedOptions } from '../../utils/uri.utilities'
import { FacetName } from '../../__generated__/fed-graphql-types'
import { getFacetConfig, isToggleFacet } from './facet-filter.map'
import { useForm } from './form.context'
import { MultiSelectProp } from './types'
import { SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet } from '../../contexts/search-results-context/query/__generated__/search-results-facets.fed.query'

interface FacetContextProps {
    facetName: FacetName
    selected: boolean
    isDisabled: boolean
    facet: SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet
    updateSelected: (filters: FilterWithSelectedOptions[]) => void
}
export const defaultValue = {
    facetName: null as unknown as FacetName,
    selected: false,
    facet: {},
    isDisabled: false,
    updateSelected: (filters: FilterWithSelectedOptions[]) => {},
} as FacetContextProps
export const FacetContext = React.createContext<FacetContextProps>(defaultValue)

const defaultFacetObj = {}

export const hasLessThanOneFilterOption = (
    isDefaultFacet: boolean,
    facetName: FacetName,
    facet: SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet
) => !isDefaultFacet && !isToggleFacet(facetName) && facet.filters.every((filter) => filter.options.length < 1)

const withFacetContext = <P extends object>(
    facetName: FacetName,
    FacetComponent: FC<P>,
    staticProps?: Partial<P & MultiSelectProp>
) => {
    const facetConfig = getFacetConfig(facetName)
    if (!facetConfig) console.log('filters not configured for ' + facetName)

    const WithFacetContext = (props: P) => {
        const { isFacetSelected, queryFacets, updateSelected, updateLastSelected } = useForm()
        const facet =
            queryFacets.find((f) => f.facet === facetName) ||
            (defaultFacetObj as SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet)

        const isDefaultFacet = facet === defaultFacetObj

        const isPreSelected =
            !isDefaultFacet &&
            (hasLessThanOneFilterOption(isDefaultFacet, facetName, facet) ||
                facet.filters.every((filter) => filter.isOnlySelected))

        const value = {
            facetName,
            selected: isFacetSelected(facetName),
            facet,
            isDisabled: isPreSelected,
            updateSelected: (filters: FilterWithSelectedOptions[]) => {
                updateLastSelected(filters[0].filter)
                updateSelected(facetName, filters)
            },
        } as FacetContextProps

        return (
            <FacetContext.Provider value={value}>
                <FacetComponent {...staticProps} {...props} />
            </FacetContext.Provider>
        )
    }

    WithFacetContext.displayName = `${FacetComponent.displayName}Filter`
    return WithFacetContext
}

const useFacet = () => React.useContext(FacetContext)

export { withFacetContext, useFacet }
